<template>
  <div class="count" :class="{ white: white }">
    <div
      class="count__button"
      :class="{ active: count > 1 }"
      @click="decrement"
    >
      <svg
        width="12"
        height="2"
        viewBox="0 0 12 2"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M0 1H12" stroke-width="1.5" />
      </svg>
    </div>
    <div class="count__value">
      <span>{{ count }}</span>
    </div>
    <div class="count__button active" @click="increment">
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.75 5.25V0H5.25V5.25H0V6.75H5.25V12H6.75V6.75H12V5.25H6.75Z"
        />
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      count: 1,
    };
  },
  props: {
    value: {
      type: Number,
      default: 1,
    },
    white: {
      type: Boolean,
    },
  },
  created() {
    this.count = this.value;
  },
  methods: {
    increment: function() {
      this.count += 1;
      this.$emit('change-count', this.count);
    },
    decrement: function() {
      if (this.count > 1) {
        this.count -= 1;
        this.$emit('change-count', this.count);
      }
      if (this.count === 1) this.$emit('change-count', this.count);
    },
  },
};
</script>

<style lang="sass" scoped>
$secodary-blue-color: #5599DD

.count
  display: flex
  font-size: 18px
  line-height: 34px
  text-align: center
  font-weight: 500
  &__value
    text-align: center
    width: 40px
    line-height: 34px
  &__button
    line-height: 0
    width: 36px
    height: 36px
    color: #B3B3B3
    border: 1px solid #B3B3B3
    border-radius: 50%
    user-select: none
    display: flex
    justify-content: center
    align-items: center
    transition: all .2s
    svg
      fill: #B2B2B2
      stroke: #B2B2B2
      transition: all .2s
    &.active
      cursor: pointer
      &:hover
        border: 1px solid $secodary-blue-color
        svg,
        path
          fill: #5599DD
          stroke: #5599DD
      &:active
        transform: scale3d(.98,.98,.98)

  &.white
    .count__button
      border: 1px solid #FFFFFF
      color: #FFFFFF
      svg
        fill: #FFFFFF
        stroke: #FFFFFF
      &.active:hover
        opacity: .6
        svg,
        path
          fill: #FFFFFF
          stroke: #FFFFFF

  @media screen and ( max-width: 1919px )
    &__button
      width: 30px
      height: 30px
      font-size: 14px
      line-height: 14px
    &__value
      width: 30px
  @media screen and ( max-width: 1279px )
    &__button
      width: 28px
      height: 28px
      font-size: 13px
      line-height: 15px
    &__value
      line-height: 28px
</style>



// WEBPACK FOOTER //
// src/templates/components/ui/count.vue